<template>
  <div
    class="flex flex-col-reverse"
    :class="[`${layoutRow ? '' : 'md:flex-row'}`]"
  >
    <div
      class="w-full relative z-10"
      :class="[
        `${imageUrl ? 'mt-[-9.6rem]' : ''}`,
        `${layoutRow ? '' : 'md:w-1/2 md:mt-0'}`,
      ]"
    >
      <div class="flex flex-col gap-8 pb-24">
        <BoxedText
          v-if="title && titleIsH1"
          box-color-class="bg-surface-primary"
          element="h1"
          text-class="heading-xl"
          >{{ title }}
        </BoxedText>
        <BoxedText
          v-else
          box-color-class="bg-surface-primary"
          element="h2"
          text-class="heading-xl"
          >{{ title }}
        </BoxedText>
        <BoxedText
          v-if="titleExtra"
          box-color-class="bg-surface-primary"
          element="h2"
          text-class="heading-xl"
        >
          {{ titleExtra }}
        </BoxedText>
        <BoxedText
          v-if="titleExtension"
          box-color-class="bg-surface-highlight"
          element="h2"
          text-class="heading-xl"
        >
          {{ titleExtension }}
        </BoxedText>
      </div>
      <div class="pb-24">
        <p v-if="text" class="heading-xs">{{ text }}</p>
        <p v-if="textLight">{{ textLight }}</p>
      </div>
      <AppUsp
        v-if="uspItems"
        class="pb-24 max-w-600"
        :items="uspItems"
        usp-direction="row"
      />
      <AppButton
        v-if="linkButtonText"
        class="pb-24"
        size="sm"
        color="primary"
        :href="linkButtonUrl"
        >{{ linkButtonText }}</AppButton
      >
      <slot></slot>
    </div>
    <div
      v-if="imageUrl"
      class="w-full overflow-hidden relative"
      :class="[`${layoutRow ? '' : 'md:flex-[0_0_auto] md:w-1/2'}`]"
    >
      <div
        class="mx-[-1.6rem] max-h-[32rem] flex items-center h-full"
        :class="[`${layoutRow ? '' : 'md:mx-0 md:max-h-none'}`]"
      >
        <NuxtImg
          loading="lazy"
          class="w-full h-auto"
          :class="[`${layoutRow ? '' : 'md:absolute'}`]"
          :src="imageUrl"
          :alt="imageAlt ?? ''"
          :provider="
            imageUrl?.includes('cloudfront') ? 'cloudfront' : undefined
          "
        />
        <AppLabel
          v-if="labelText"
          :color="labelColor"
          :text="labelText"
          class="top-24 right-16 absolute"
          :class="[`${layoutRow ? '' : 'md:top-32 md:right-48'}`]"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  title?: string;
  titleIsH1?: boolean;
  titleExtra?: string;
  titleExtension?: string;
  text?: string;
  textLight?: string;
  linkButtonText?: string;
  linkButtonUrl?: string;
  imageUrl?: string;
  imageAlt?: string;
  labelColor?: string;
  labelText?: string;
  uspItems?: {
    Icon: string;
    Label: string;
    SubLabel?: string;
  }[];
  layoutRow?: boolean;
}
defineProps<Props>();
</script>
<style scoped></style>
